<template>
  <div class="deposit-amount">
    <input
      class="deposit-amount__value input__item-text"
      v-model="value"
      @input="changeAmount"
      placeholder="Введите сумму пополнения"
    />
    <div class="deposit-amount__currency">
      <div class="deposit-amount__currency-selected" @click="showOptions = !showOptions">
        <!-- {{ selectedCurrency }} -->
        <!-- {{ addAccount === 'google' ? $t('currency.currency_symbol') : currency_symbols[currency] }} -->
        <!-- {{ currency_symbols[currency] }} -->
        <!-- <img v-if="isCurrencyChange" src="@/assets/icons/icon-arrow.svg" alt="arrow"> -->
        {{ $t('currency.currency_symbol') }}
      </div>
      <!-- <div v-if="showOptions && isCurrencyChange" class="deposit-amount__currency-options">
        <div class="deposit-amount__currency-item" @click="changeCurrency('₽')">
          ₽
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
export default {
  name: 'DepositAmount',
  props: {
    campaignId: {
      type: [String, Number],
      default: null,
    },
    accountName: [String, Number],
    default: null,
    defaultValue: {
      type: String,
      default: null,
    },
    isCurrencyChange: {
      type: Boolean,
      default: true,
    },
    currency: {
      type: String,
      default: '',
    },
    addAccount: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value: 5000,
      selectedCurrency: '₽',
      showOptions: false,
      currency_symbols: {
        RUB: '₽',
        USD: '$',
        EUR: '€',
        PLN: 'zł',
      },
    };
  },
  created() {
    // this.initCurrency()
  },
  mounted() {
    if (this.defaultValue) this.value = null;
    this.changeAmount();
  },
  methods: {
    changeCurrency(val) {
      if (this.isCurrencyChange) {
        this.selectedCurrency = val;
        this.showOptions = false;
      }
    },
    changeAmount() {
      if (this.campaignId) {
        this.$store.commit('Balance/setDepositAmount', {
          campaign_id: this.campaignId,
          amount: +this.value,
        });
      }
      if (this.accountName) {
        this.$store.commit('Balance/setData', { label: 'account', data: +this.value });
      }
    },
  },
};
</script>

<style lang="scss">
.deposit-amount {
  display: flex;

  &__value {
    width: 100%;
    margin-right: 1rem;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #d1d4d8;

    &::placeholder {
      font-weight: 400;
      font-size: 16px;
      color: #bfc2c6;
    }
  }

  &__currency {
    position: relative;

    &-selected {
      border-radius: 6px;
      height: 5rem;
      width: 5.2rem;
      font-size: 1.6rem;
      line-height: 1.9rem;
      color: #000;
      padding: 0 1rem 0 1.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
    }

    &-options {
      position: absolute;
      left: 0;
      top: calc(100% + 1rem);
      border: 1px solid #f1f4fa;
      background: #fff;
      border-radius: 6px;
      width: 5.2rem;
      font-size: 1.6rem;
      line-height: 1.9rem;
      color: #000;
      z-index: 2;
    }

    &-selected {
      border: 1px solid #d1d4d8;
      border-radius: 6px;
      height: 5rem;
      width: 5.2rem;
      font-size: 1.6rem;
      line-height: 1.9rem;
      color: #000;
      padding: 0 1rem 0 1.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      padding: 0;
      justify-content: center;
    }
    &-item {
      padding: 0.75rem 1.5rem;
      transition: 0.3s ease-out;
      cursor: pointer;

      &:hover {
        color: #2f80ed;
      }
    }
  }
}
</style>
